export default __webpack_public_path__ + "static/media/abb-logo.e1c16df5.png";